module.exports = __webpack_public_path__ + "img/5.dca9a37f.jpg";